import { graphql, Link } from 'gatsby';
import React from 'react';

import _ from 'lodash';
import { generateImageCdnPath, IMAGE_SIZE_MEDIUM } from '../utils/images';
/* How to use this component:
   Make your GraphQL call for your desired products in your layout component.
   In the layout, pass the products as props, either via MDXRenderer to 
   a markdown file, or directly to this component.
   See index.js and homepage.mdx for an example on using with MDX.
*/
const FeaturedProducts = (props) => {
  const {
    featuredProducts,
    headline,
    description,
    link,
    linkText,
    optionalAdditionalResourceLink,
    optionalAdditionalResourceText,
  } = props;
  const renderProduct = (product, index) => {
    const { BotanicalName, CommonName, Name, Price, Slug } = product.node;
    const productImgUrl = generateImageCdnPath(
      product.node.ImageHashes[0],
      IMAGE_SIZE_MEDIUM,
    );
    return (
      <div
        key={index}
        className="cell small-12 medium-6 large-3 product-thumb--card"
      >
        <Link
          to={`/organic-plants/${Slug}`}
          className="product-thumb--link__product"
        >
          <div
            className="product-thumb--image"
            style={{ backgroundImage: `url(${productImgUrl})` }}
          />
          {BotanicalName ? (
            <p className="product-thumb--title">
              <em>{BotanicalName}</em> <br />
              <strong>{CommonName}</strong>
            </p>
          ) : (
            <p className="product-thumb--title">
              <strong>{Name}</strong>
            </p>
          )}
          <div>
            <p className="product-thumb---price">
              <span>$</span>
              <span>{Price}</span> / 3" pot
            </p>
          </div>
        </Link>
      </div>
    );
  };

  return (
    <div className="featured-product--row">
      <div className="grid-x">
        <div className="cell small-12 medium-6 medium-offset-3">
          {headline && <h3>{headline}</h3>}
          {description && <p>{description}</p>}
        </div>
      </div>
      <div className="grid-x grid-margin-x grid-margin-y">
        {_.map(featuredProducts, renderProduct)}
        <div className="featured-product--resources cell small-12 medium-3">
          <p>
            <strong>
              <Link to={link}>{linkText}</Link>
            </strong>
          </p>
          {optionalAdditionalResourceLink && (
            <p>
              <strong>
                <Link to={optionalAdditionalResourceLink}>
                  {optionalAdditionalResourceText}
                </Link>
              </strong>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default FeaturedProducts;
